import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChildren,
} from '@angular/core';
import { TuiAlertService } from '@taiga-ui/core';
import { HistoryServicesService } from 'src/app/services/history-services/history-services.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { verticalTypes3 } from 'src/app/constants/data';
import { Zone } from 'src/app/models/zone/zone.model';
import { VerticalTypeTwo } from 'src/app/models/vertical-type/vertical-type.model';
import {
  FeeDetail,
  GeneralPricesResponse,
  Price,
  ProductDetail,
  ProductToUpdate,
  UpdateGeneralPricesFeesDetails,
  UpdateGeneralPricesProductDetails,
  UpdateVerticalPricesByZoneRequest,
  VerticalDetail,
} from 'src/app/models/prices/prices.model';
import { finalize } from 'rxjs';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

type ProductField =
  | 'b2cMobility'
  | 'b2bMobility'
  | 'premiumMobility'
  | 'hybridMobility'
  | 'b2cProvider'
  | 'b2bProvider'
  | 'premiumProvider'
  | 'hybridProvider';

const TOPPINGVERTICAL = 'toppings';

@Component({
  selector: 'app-prices-table',
  templateUrl: './prices-table.component.html',
  styleUrls: ['./prices-table.component.css'],
})
export class PricesTableComponent implements OnInit {
  @ViewChildren('verticalContainer')
  verticalContainers!: QueryList<ElementRef>;

  private lastEditedIndex: number | null = null;

  readonly sizes = ['l', 'm', 's'] as const;
  size = this.sizes[0];
  bsModalRef?: BsModalRef;

  expandedVerticals = new Set<string>();
  activeEditVertical = '';

  // Formularios reactivos
  feedForm!: FormGroup;
  productForm!: FormGroup;

  readonly columns = [
    'vertical',
    'movi_b2c',
    'prov_b2c',
    'movi_b2b',
    'prov_b2b',
    'movi_pre',
    'prov_pre',
    'movi_hyb',
    'prov_hyb',
    'actions',
  ] as const;

  private readonly VERTICALS_WITHOUT_PROVIDER = new Set<string>([
    'Transfer',
    'ReplacementVehicle',
    'LongDistanceTransfer',
  ]);

  readonly columns_tarifas = ['fees', 'price', 'actions'] as const;
  verticalsTypes: VerticalTypeTwo[] = verticalTypes3;
  feeds: FeeDetail[] = [];
  zones: Zone[] = [];
  verticalDetails: VerticalDetail[] = [];

  isLoadingZones = true;
  isLoading = false;
  isSavingProduct = false;
  isLoadingEditFeed = false;
  isSavingVertical = false;

  selectedZone: string | null = null;

  activeEditPrice = '';
  activeEditProduct = '';

  feeSortColumn: keyof FeeDetail | null = null;
  feeSortDirection: 1 | -1 | 0 = 0;

  productSortColumn: string | null = null;
  productSortDirection: 1 | -1 | 0 = 0;

  private productColumnMap: Record<string, keyof ProductDetail | null> = {
    vertical: 'productKey',
    movi_b2c: 'b2cMobilityPrice',
    prov_b2c: 'b2cProviderPrice',
    movi_b2b: 'b2bMobilityPrice',
    prov_b2b: 'b2bProviderPrice',
    movi_pre: 'premiumMobilityPrice',
    prov_pre: 'premiumProviderPrice',
    movi_hyb: 'hybridMobilityPrice',
    prov_hyb: 'hybridProviderPrice',
    actions: null,
  };

  editingVertical: string | null = null;
  priceForms: Record<string, FormGroup> = {};
  currency: string = '€';

  constructor(
    private alerts: TuiAlertService,
    private modalService: BsModalService,
    public historyService: HistoryServicesService,
    public translate: TranslateService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.initFeedForm();
    this.initProductForm();
    this.loadZones();
  }

  shouldShowProviderColumns(verticalName: string): boolean {
    return !this.VERTICALS_WITHOUT_PROVIDER.has(verticalName);
  }

  private initFeedForm(): void {
    this.feedForm = this.fb.group({
      price: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
    });
  }

  private initProductForm(): void {
    this.productForm = this.fb.group({
      b2cMobility: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
      b2cProvider: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
      b2bMobility: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
      b2bProvider: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
      hybridMobility: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
      hybridProvider: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
      premiumMobility: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
      premiumProvider: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
          Validators.min(0),
          Validators.max(99999),
        ],
      ],
    });
  }

  private scrollToLastEdited(): void {
    if (
      this.lastEditedIndex !== null &&
      this.verticalContainers.length > this.lastEditedIndex
    ) {
      const el = this.verticalContainers.toArray()[this.lastEditedIndex]
        .nativeElement as HTMLElement;

      const topOfElement = el.getBoundingClientRect().top + window.pageYOffset;
      const headerHeight = 64;
      const extraMargin = 600;

      const scrollTo = topOfElement - headerHeight - extraMargin;
      window.scrollTo({ top: scrollTo, behavior: 'smooth' });

      this.lastEditedIndex = null;
    }
  }

  private loadZones(): void {
    this.historyService.getZones().subscribe({
      next: (res: { zones: Zone[] }) => {
        this.zones = res.zones;
        this.isLoadingZones = false;
      },
      error: () => {
        this.isLoadingZones = false;
        this.showErrorAlert(
          this.translate.instant('comercial.prices.zonesLoadError')
        );
      },
    });
  }

  filterDataByZone(isEditingVertical: boolean = false): void {
    if (!this.selectedZone) {
      this.resetData();
      return;
    }
    this.getPricesByZones(isEditingVertical);
  }

  resetData(): void {
    this.verticalDetails = [];
    this.feeds = [];
  }

  toggleSection(verticalName: string): void {
    this.expandedVerticals.has(verticalName)
      ? this.expandedVerticals.delete(verticalName)
      : this.expandedVerticals.add(verticalName);
  }

  isExpanded(verticalName: string): boolean {
    return this.expandedVerticals.has(verticalName);
  }

  enterEditMode(verticalName: string): void {
    if (this.editingVertical) {
      return;
    }
    this.editingVertical = verticalName;
    const vertical = this.verticalDetails.find(
      (v) => v.verticalName === verticalName
    )!;

    const productsFA = this.fb.array(
      vertical.productDetails.map((p) =>
        this.fb.group({
          b2cMobility: [
            this.formatFeePrice(p.b2cMobilityPrice),
            [Validators.required, Validators.min(0), Validators.max(99999)],
          ],
          b2bMobility: [
            this.formatFeePrice(p.b2bMobilityPrice),
            [Validators.required, Validators.min(0), Validators.max(99999)],
          ],
          premiumMobility: [
            this.formatFeePrice(p.premiumMobilityPrice),
            [Validators.required, Validators.min(0), Validators.max(99999)],
          ],
          hybridMobility: [
            this.formatFeePrice(p.hybridMobilityPrice),
            [Validators.required, Validators.min(0), Validators.max(99999)],
          ],
          b2cProvider: [
            this.formatFeePrice(p.b2cProviderPrice),
            [Validators.required, Validators.min(0), Validators.max(99999)],
          ],
          b2bProvider: [
            this.formatFeePrice(p.b2bProviderPrice),
            [Validators.required, Validators.min(0), Validators.max(99999)],
          ],
          premiumProvider: [
            this.formatFeePrice(p.premiumProviderPrice),
            [Validators.required, Validators.min(0), Validators.max(99999)],
          ],
          hybridProvider: [
            this.formatFeePrice(p.hybridProviderPrice),
            [Validators.required, Validators.min(0), Validators.max(99999)],
          ],
        })
      )
    );

    this.priceForms[verticalName] = this.fb.group({ products: productsFA });
  }

  cancelEdit(verticalName: string): void {
    if (this.editingVertical === verticalName) {
      this.editingVertical = null;
    }
  }

  private validateVerticalForm(verticalName: string): FormArray | null {
    const fg = this.priceForms[verticalName];

    if (!fg) {
      this.alerts
        .open(this.translate.instant('comercial.prices.formNotFound'), {
          status: 'error',
        })
        .subscribe();
      return null;
    }

    const productsFA = fg.get('products') as FormArray;

    if (productsFA.invalid) {
      this.alerts
        .open(this.translate.instant('comercial.prices.invalidForm'), {
          status: 'error',
        })
        .subscribe();
      return null;
    }

    return productsFA;
  }

  private mapProductsData(
    verticalName: string,
    productsFA: FormArray
  ): ProductDetail[] {
    const original = this.verticalDetails.find(
      (v) => v.verticalName === verticalName
    )!;

    const keyMap = {
      b2cMobility: 'b2cMobilityPrice',
      b2cProvider: 'b2cProviderPrice',
      b2bMobility: 'b2bMobilityPrice',
      b2bProvider: 'b2bProviderPrice',
      premiumMobility: 'premiumMobilityPrice',
      premiumProvider: 'premiumProviderPrice',
      hybridMobility: 'hybridMobilityPrice',
      hybridProvider: 'hybridProviderPrice',
    } as const;
    type KeyMap = typeof keyMap;
    type ShortKey = keyof KeyMap; 
    type LongKey = KeyMap[ShortKey];

    return original.productDetails.map((orig, i) => {
      const grp = productsFA.at(i) as FormGroup;
      const updated: ProductDetail = { ...orig };

      (Object.keys(keyMap) as ShortKey[]).forEach((shortKey) => {
        const ctrl = grp.get(shortKey);
        if (!ctrl) {
          return;
        }

        const priceKey: LongKey = keyMap[shortKey];
        updated[priceKey] = this.convertToPriceFormat(String(ctrl.value));
      });

      return updated;
    });
  }

  private buildUpdateRequest(
    verticalName: string,
    productsData: ProductDetail[]
  ): UpdateVerticalPricesByZoneRequest {
    return {
      zoneId: this.selectedZone!,
      productToUpdate: {
        verticalName,
        productsData,
      },
    };
  }

  saveVerticalEdits(verticalName: string): void {
    if (this.isSavingVertical) {
      return;
    }

    if (!this.selectedZone) {
      this.alerts
        .open(this.translate.instant('comercial.prices.noZoneSelected'), {
          status: 'error',
        })
        .subscribe();
      return;
    }

    const productsFA = this.validateVerticalForm(verticalName);
    if (!productsFA) {
      return;
    }

    const productsData = this.mapProductsData(verticalName, productsFA);
    const payload = this.buildUpdateRequest(verticalName, productsData);

    this.lastEditedIndex = this.verticalDetails.findIndex(
      (v) => v.verticalName === verticalName
    );

    this.isSavingVertical = true;
    this.historyService
      .updateVerticalPricesByZone(payload)
      .pipe(finalize(() => (this.isSavingVertical = false)))
      .subscribe({
        next: (response) => {
          if (response.isSuccess) {
            this.alerts
              .open(
                this.translate.instant('comercial.prices.verticalSaveSuccess'),
                { status: 'success' }
              )
              .subscribe();

            this.editingVertical = null;
            this.filterDataByZone(true);
          } else {
            this.alerts
              .open(
                this.translate.instant('comercial.prices.verticalSaveError'),
                { status: 'error' }
              )
              .subscribe();
          }
        },
        error: (err) => {
          this.alerts
            .open(
              err?.message ??
                this.translate.instant('comercial.prices.verticalSaveError'),
              { status: 'error' }
            )
            .subscribe();
        },
      });
  }

  isToppingsSection(verticalName: string): boolean {
    return verticalName === TOPPINGVERTICAL;
  }

  getProductControl(
    verticalName: string,
    rowIndex: number,
    field: ProductField
  ): FormControl<number | null> {
    const fa = this.priceForms[verticalName].get('products') as FormArray;
    return fa.at(rowIndex).get(field) as FormControl<number | null>;
  }

  getPricesByZones(isEditingVertical: boolean = false): void {
    if (!this.selectedZone) {
      return;
    }

    this.isLoading = true;

    this.historyService
      .getPricesByZone(this.selectedZone)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res: GeneralPricesResponse) => {
          this.feeds = res.feesDetails;
          this.currency = res.currencySymbol || '€';

          const toppingsVertical: VerticalDetail = {
            verticalName: TOPPINGVERTICAL,
            productDetails: res.toppingDetails,
          };

          this.verticalDetails = [...res.verticalDetails, toppingsVertical];

          if (this.lastEditedIndex !== null && isEditingVertical) {
            setTimeout(() => this.scrollToLastEdited(), 300);
          }
        },
        error: () => {
          this.isLoading = false;
          this.resetData();
          this.showErrorAlert(
            this.translate.instant('comercial.prices.pricesLoadError')
          );
        },
      });
  }

  private feeKey(name: string): string {
    return name.trim().toLowerCase().replace(/\s+/g, '_');
  }

  translateFee(name: string): string {
    const key = this.feeKey(name);
    const path = `comercial.prices.${key}`;
    const translated = this.translate.instant(path);
    return translated !== path ? translated : name;
  }

  private showSuccessAlert(message: string): void {
    this.alerts
      .open(message, {
        label: this.translate.instant('comercial.prices.alertLabelSuccess'),
        status: 'success',
        autoClose: 5000,
      })
      .subscribe();
  }

  private showErrorAlert(message: string): void {
    this.alerts
      .open(message, {
        label: this.translate.instant('comercial.prices.alertLabelError'),
        status: 'error',
        autoClose: false,
      })
      .subscribe();
  }

  openModal(
    editClientPriceModal: TemplateRef<void>,
    feeName: string,
    currentPrice: string
  ): void {
    this.feedForm.patchValue({ price: currentPrice });
    this.activeEditPrice = feeName;
    this.bsModalRef = this.modalService.show(editClientPriceModal);
  }

  private updateProductFormValidators(verticalName: string): void {
    const requiresProvider = this.shouldShowProviderColumns(verticalName);

    const providerFields = [
      'b2cProvider',
      'b2bProvider',
      'hybridProvider',
      'premiumProvider',
    ];

    providerFields.forEach((field) => {
      const control = this.productForm.get(field);
      if (!control) return;

      if (requiresProvider) {
        control.setValidators([
          Validators.required,
          Validators.pattern(/^\d*\.?\d*$/),
        ]);
      } else {
        control.clearValidators();
      }

      control.updateValueAndValidity();
    });
  }

  openEditProductModal(
    template: TemplateRef<unknown>,
    verticalName: string,
    product: ProductDetail
  ): void {
    this.activeEditVertical = verticalName;
    this.activeEditProduct = product.productKey;

    this.productForm.patchValue({
      b2cMobility: this.formatFeePrice(product.b2cMobilityPrice),
      b2cProvider: this.formatFeePrice(product.b2cProviderPrice),
      b2bMobility: this.formatFeePrice(product.b2bMobilityPrice),
      b2bProvider: this.formatFeePrice(product.b2bProviderPrice),
      premiumMobility: this.formatFeePrice(product.premiumMobilityPrice),
      premiumProvider: this.formatFeePrice(product.premiumProviderPrice),
      hybridMobility: this.formatFeePrice(product.hybridMobilityPrice),
      hybridProvider: this.formatFeePrice(product.hybridProviderPrice),
    });

    this.updateProductFormValidators(verticalName);

    this.bsModalRef = this.modalService.show(template);
  }

  getVerticalRealName(name: string): string {
    if (name === 'topping') {
      return TOPPINGVERTICAL;
    }
    const found = this.verticalsTypes.find((v) => v.name === name);
    return found ? found.realName : name;
  }

  private convertToPriceFormat(
    input: string | number | null | undefined
  ): Price {
    const txt = String(input ?? '')
      .trim()
      .replace(',', '.');
    const num = parseFloat(txt);

    if (!Number.isFinite(num) || num < 0) {
      return { units: '0', nanos: 0 };
    }

    const units = Math.trunc(num);
    const nanos = Math.round((num - units) * 1e9);

    return { units: units.toString(), nanos };
  }

  get activeEditProductDisplay(): string {
    const [code, ...rest] = this.activeEditProduct.split(' ');
    const translated = this.historyService.translate2(
      this.translate.currentLang,
      code
    );
    return `${translated} ${rest.join(' ')}`;
  }

  saveModalFeeds(): void {
    if (this.feedForm.invalid) {
      return this.showErrorAlert(
        this.translate.instant('comercial.prices.formInvalidPrice')
      );
    }
    if (!this.selectedZone) {
      return this.showErrorAlert(
        this.translate.instant('comercial.prices.noZoneSelected')
      );
    }

    const priceNum = parseFloat(this.feedForm.get('price')!.value as string);
    if (isNaN(priceNum) || priceNum < 0) {
      return this.showErrorAlert(
        this.translate.instant('comercial.prices.negativePrice')
      );
    }

    const payload: UpdateGeneralPricesFeesDetails = {
      zoneId: this.selectedZone,
      feeToUpdate: {
        feeName: this.activeEditPrice,
        newPrice: priceNum,
      },
    };

    this.isLoadingEditFeed = true;
    this.historyService
      .updatePricesFeesByZone(payload)
      .pipe(finalize(() => (this.isLoadingEditFeed = false)))
      .subscribe({
        next: () => {
          this.showSuccessAlert(
            this.translate.instant('comercial.prices.successSaveProduct')
          );

          setTimeout(() => {
            this.filterDataByZone(false);
            this.bsModalRef?.hide();
          }, 50);
        },
        error: (err: any) => {
          this.showErrorAlert(
            err?.message ||
              this.translate.instant('comercial.prices.errorSaveFee')
          );
        },
      });
  }

  saveModalPrices(): void {
    if (!this.selectedZone) {
      return this.showErrorAlert(
        this.translate.instant('comercial.prices.noZoneSelected')
      );
    }
    if (!this.activeEditVertical) {
      return this.showErrorAlert(
        this.translate.instant('comercial.prices.noVerticalSelected')
      );
    }
    if (this.productForm.invalid) {
      return this.showErrorAlert(
        this.translate.instant('comercial.prices.invalidProductForm')
      );
    }

    const pd = this.productForm.value;
    const productData: ProductToUpdate['productData'] = {
      productKey: this.activeEditProduct,
      b2cMobilityPrice: this.convertToPriceFormat(pd.b2cMobility),
      b2cProviderPrice: this.convertToPriceFormat(pd.b2cProvider),
      b2bMobilityPrice: this.convertToPriceFormat(pd.b2bMobility),
      b2bProviderPrice: this.convertToPriceFormat(pd.b2bProvider),
      hybridMobilityPrice: this.convertToPriceFormat(pd.hybridMobility),
      hybridProviderPrice: this.convertToPriceFormat(pd.hybridProvider),
      premiumMobilityPrice: this.convertToPriceFormat(pd.premiumMobility),
      premiumProviderPrice: this.convertToPriceFormat(pd.premiumProvider),
    };

    const payload: UpdateGeneralPricesProductDetails = {
      zoneId: this.selectedZone,
      productToUpdate: {
        verticalName: this.activeEditVertical,
        productData,
      },
    };

    this.isSavingProduct = true;
    this.historyService
      .updateProductsPricesByZone(payload)
      .pipe(finalize(() => (this.isSavingProduct = false)))
      .subscribe({
        next: () => {
          this.showSuccessAlert(
            this.translate.instant('comercial.prices.successSaveProduct')
          );

          setTimeout(() => {
            this.filterDataByZone(true);
            this.bsModalRef?.hide();
            this.activeEditVertical = '';
          }, 50);
        },
        error: (err: Error) => {
          this.showErrorAlert(err.message);
        },
      });
  }

  trackByFee = (_: number, fee: FeeDetail) => fee.feeName;
  trackByVertical = (_: number, v: VerticalDetail) => v.verticalName;
  trackByProductInSection = (_: number, prod: ProductDetail) => prod.productKey;

  public formatFeePrice(price: Price): string {
    const amount = Number(price.units) + price.nanos / 1e9;
    return amount.toFixed(2);
  }

  setFeeSortColumn(column: keyof FeeDetail): void {
    if (this.feeSortColumn === column) {
      this.feeSortDirection =
        this.feeSortDirection === 0 ? 1 : this.feeSortDirection === 1 ? -1 : 0;
      if (this.feeSortDirection === 0) {
        this.feeSortColumn = null;
      }
    } else {
      this.feeSortColumn = column;
      this.feeSortDirection = 1;
    }
  }

  get sortedFeeds(): FeeDetail[] {
    const list = [...this.feeds];
    if (!this.feeSortColumn || this.feeSortDirection === 0) {
      return list;
    }

    return list.sort((a, b) => {
      const aVal = a[this.feeSortColumn!];
      const bVal = b[this.feeSortColumn!];
      let diff = 0;

      if (typeof aVal === 'string' && typeof bVal === 'string') {
        diff = aVal.localeCompare(bVal);
      } else if (typeof aVal === 'object' && typeof bVal === 'object') {
        const numA = Number((aVal as any).units) + (aVal as any).nanos / 1e9;
        const numB = Number((bVal as any).units) + (bVal as any).nanos / 1e9;
        diff = numA - numB;
      }

      return this.feeSortDirection * diff;
    });
  }

  setProductSortColumn(col: string): void {
    if (this.productSortColumn === col) {
      this.productSortDirection =
        this.productSortDirection === 0
          ? 1
          : this.productSortDirection === 1
          ? -1
          : 0;
      if (this.productSortDirection === 0) {
        this.productSortColumn = null;
      }
    } else {
      this.productSortColumn = col;
      this.productSortDirection = 1;
    }
  }

  getSortedProducts(item: VerticalDetail): ProductDetail[] {
    const list = [...item.productDetails];
    if (!this.productSortColumn || this.productSortDirection === 0) {
      return list;
    }

    const field = this.productColumnMap[this.productSortColumn];
    if (!field) {
      return list;
    }

    return list.sort((a, b) => {
      const aVal = a[field];
      const bVal = b[field];
      let diff = 0;

      if (typeof aVal === 'string' && typeof bVal === 'string') {
        diff = aVal.localeCompare(bVal);
      } else if (typeof aVal === 'object' && typeof bVal === 'object') {
        const numA = Number((aVal as any).units) + (aVal as any).nanos / 1e9;
        const numB = Number((bVal as any).units) + (bVal as any).nanos / 1e9;
        diff = numA - numB;
      }

      return this.productSortDirection * diff;
    });
  }
}
